export enum FuelType {
  DIESEL = 'Diesel',
  GAS = 'Gas',
  Electricity = 'Electricity',
  PETROL92 = 'Petrol-92',
  PETROL95 = 'Petrol-95',
  PETROL98 = 'Petrol-98',
  PETROL100 = 'Petrol-100',
}
